import { render, staticRenderFns } from "./NoticeMessage.vue?vue&type=template&id=dc8e7d4a&scoped=true&"
import script from "./NoticeMessage.vue?vue&type=script&lang=js&"
export * from "./NoticeMessage.vue?vue&type=script&lang=js&"
import style0 from "./NoticeMessage.vue?vue&type=style&index=0&id=dc8e7d4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc8e7d4a",
  null
  
)

export default component.exports